import sendToServer from './send-to-server';

const CoverLetters = {
  init() {
    if (!($('.cover-letters').length > 0)) return;

    $('.helper').click(this.handleHelperButtonClick.bind(this));

    if (!($('.cover-letters .editable').length > 0)) return;

    $('.document-viewer.editable .cover-letter-component').mouseover(this.handleMouseoverComponent.bind(this));
    $('.document-viewer.editable .cover-letter').mouseleave(this.handleMouseleaveLetter.bind(this));
    $('.document-viewer.editable .cover-letter-component').click(this.handleComponentClick.bind(this));
    $('.cancel-button').click(this.handleCancelButtonClick.bind(this));
    $('.submit-button').click(this.handleSubmitButtonClick.bind(this));
  },

  handleMouseoverComponent(event) {
    const $component = $(event.target).closest('.cover-letter-component');
    $('.cover-letter-component').removeClass('hovering');
    $component.addClass('hovering')
  },

  handleMouseleaveLetter() {
    $('.cover-letter-component').removeClass('hovering');
  },

  handleComponentClick(event) {
    const $component = $(event.target).closest('.cover-letter-component');
    $('#id-holder').val($component.data('component-id'));
    $('#text-holder').val($component.data('props').text);

    $(document).scrollTop(0);
    $('.edit-box').fadeIn(100);
  },

  handleCancelButtonClick() {
    $('.edit-box').fadeOut(100);
  },

  handleSubmitButtonClick(event) {
    sendToServer('/api/v2/cover_letter_components/' + $('#id-holder').val(),
                 { text: $('#text-holder').val()},
                 ()=> { location.reload() },
                 'PATCH');
  },

  handleHelperButtonClick() {
    $('#help-flag').val(1);
    $('.checkpoint-1').focus();
  }
};

$(document).ready(()=> {
  CoverLetters.init();
});
